import type { FormEvent, KeyboardEvent } from "react";

/**
 * Wire with `<form onKeyDown={onEnterToSubmitKeyDown} onSubmit={...}>`.
 *
 * Native HTML already submits on Enter from inputs/selects.
 * Textareas keep newline on Enter; Ctrl+Enter / Cmd+Enter submits.
 */
export function onEnterToSubmitKeyDown(e: KeyboardEvent<HTMLFormElement>): void {
  if (e.key !== "Enter") return;
  const target = e.target as HTMLElement | null;
  if (!target || target.tagName !== "TEXTAREA") return;
  if (e.metaKey || e.ctrlKey) {
    e.preventDefault();
    e.currentTarget.requestSubmit();
  }
}

/** Standard submit handler wrapper — always preventDefault, then run async/sync save. */
export function handleFormSubmit(
  e: FormEvent<HTMLFormElement>,
  save: () => void | Promise<void>
): void {
  e.preventDefault();
  void save();
}
